module.exports = __webpack_public_path__ + "static/media/logo.f1c2007b.png";